import { Observable } from 'rxjs';
import { Inject, Injectable } from '../../injection';
import { MobizSettings } from '../data/mobiz-settings.do';
import { SynchronizationSettings } from '../data/synchronization-settings.do';
import { IMobizSettingsService } from '../interfaces/mobiz-settings.interface';
import { ISynchronizationSettingsService } from '../interfaces/synchronization-settings.interface';
import { MobizSettingsScope } from '../other/mobiz-settings-scope.type';
import { MobizSettingsKeyOrganization } from '../other/mobiz-settings.type';

@Injectable()
export class SynchronizationSettingsService implements ISynchronizationSettingsService {
  private readonly settingsKey: MobizSettingsKeyOrganization = 'SynchronizationSettings';
  private readonly settingsScope: MobizSettingsScope = 'organization';

  constructor(
    @Inject(IMobizSettingsService)
    private settingsService: IMobizSettingsService,
  ) {
  }

  public get(
    organizationId: string,
  ): Observable<MobizSettings<SynchronizationSettings>> {
    let settingsInstance = new MobizSettings<SynchronizationSettings>(SynchronizationSettings);
    return this.settingsService.get<SynchronizationSettings>(this.settingsScope, organizationId, this.settingsKey, settingsInstance);
  }

  public set(
    organizationId: string,
    settingsValue: MobizSettings<SynchronizationSettings>,
  ): Observable<MobizSettings<SynchronizationSettings>> {
    if (settingsValue.origin === 'DB') {
      return this.settingsService.update(this.settingsScope, organizationId, this.settingsKey, settingsValue);
    }
    return this.settingsService.add(this.settingsScope, organizationId, this.settingsKey, settingsValue);
  }
}
